import {  Grid, TextField, Button, IconButton } from '@material-ui/core';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import CloseIcon from '@material-ui/icons/Close';
//import Alert from '@material-ui/lab/Alert';
import StatusDisplay from './StatusDisplay'

const useStyles = makeStyles((theme) => ({
    signinbtn: {
        fontFamily: 'Open Sans',
        fontWeight: 400,
        fontSize: 18,
        backgroundColor: "#1867B8",
        width: 160,
        height: 40,
        color: '#FFFFFF',
        margin: 20,
        borderRadius: 0,
        '&:hover': {
            backgroundColor: "#1867B8",
            color: '#FFFFFF',
        }

    }
}));

const VerifyCodeDialog = ( {open,title,message,buttonlabel,okCallback,closeCallback
        ,isRunning,successMessage,setSuccessMessage,error,setError} )=>{

    const classes = useStyles();
    let [code, setCode] = useState("");
    
    // Clear the code field when there's an error
    useEffect(() => {
        if (error && error !== '') {
            setCode("");
        }
    }, [error]);
    
    return (
        <Dialog fullWidth={true} open={open} maxWidth='sm' disableBackdropClick disableEscapeKeyDown  aria-labelledby="max-width-dialog-title">
            <Grid item xs={12} container>
                <Grid item xs={11}> <DialogTitle id="verify-authapp-user-dilaog">{title}</DialogTitle> </Grid>
                <Grid item xs={1}> <IconButton onClick={()=>{closeCallback();}}> <CloseIcon /> </IconButton> </Grid>
            </Grid>
        <DialogContent>                                    
            <StatusDisplay isRunning={isRunning}  successMessage={successMessage} setSuccessMessage={setSuccessMessage} error={error} setError={setError} ></StatusDisplay>
            <div style={{textAlign:'center'}}>
                <div> {message} </div>
                <div style={{marginTop:'25px'}}>
                    <TextField id="authappcode" name="authappcode" autoFocus variant="outlined" inputProps={{ maxLength: 6 }} 
                            style={{ marginBottom: '10px', width: '240px' }} required={true} 
                            value={code}
                            onChange={(e=>{ 
                                setCode( e.target.value);
                                // Clear error message when user starts typing
                                if (error && error !== '') {
                                    setError('');
                                }
                             })}
                             onKeyDown={(e=>{
                                if (e.key === 'Enter'){okCallback(e.target.value);}
                             })}
                    />
                </div>
                <div><Button variant="contained" color="primary"  onClick={e=>{okCallback(code);} } disabled={isRunning || !code || code.length === 0} className={classes.signinbtn}> {buttonlabel} </Button></div>
            </div>
        </DialogContent>
    </Dialog>
    );
}
export default VerifyCodeDialog;